import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { CheckCircle } from '@material-ui/icons';
import { Grid } from '@material-ui/core';
import { Button } from 'react-bootstrap';
import {
  resetRemoveDRWizard,
  selectCreatedRequestId,
  selectSelectedRestrictions,
  selectRequestCreatedButFilesFailed
} from '../../../../../redux/features/lender-request/removeDeliveryRestrictionSlice';

const SuccessPage = ({ projectId, createdRequestId, selectedRestrictions, requestCreatedButFilesFailed, resetRemoveDRWizard }) => {
  const history = useHistory();

  const handleBackToProject = () => {
    resetRemoveDRWizard();
    history.push(`/project/${projectId}`);
  };

  const handleViewRequests = () => {
    resetRemoveDRWizard();
    history.push('/lender-requests');
  };

  return (
    <Grid item xs={12} style={{ textAlign: "center", padding: "40px" }}>
      <Grid item xs={12} style={{ marginBottom: "20px" }}>
        <CheckCircle style={{ fontSize: "80px", color: "#28a745", marginBottom: "20px" }} />
        <h1>Request Submitted Successfully!</h1>
      </Grid>
      
      <Grid item xs={12} style={{ marginBottom: "30px" }}>
        <h6>Step 4 of 4 - Completion</h6>
        <p style={{ fontSize: "16px", marginBottom: "30px" }}>
          Your request to remove delivery restrictions has been submitted and is now pending review by Fannie Mae.
        </p>
      </Grid>

      {/* File Upload Failure Warning */}
      {requestCreatedButFilesFailed && (
        <Grid item xs={12} style={{ 
          display: "flex",
          justifyContent: "center",
          marginBottom: "20px"
        }}>
          <div style={{ 
            background: "#fff3cd", 
            padding: "15px", 
            borderRadius: "8px", 
            color: "#856404",
            maxWidth: "600px",
            width: "100%",
            textAlign: "left",
            border: "1px solid #ffc107"
          }}>
            <h4>⚠️ Partial Success</h4>
            <p style={{ margin: 0, textAlign: "left" }}>
              Your request was submitted successfully, but file uploads failed. Please use the 
              'Add Document' button from the project page to upload the missing files.
            </p>
          </div>
        </Grid>
      )}

      {/* Request Summary */}
      <Grid item xs={12} style={{ 
        display: "flex",
        justifyContent: "center",
        marginBottom: "30px"
      }}>
        <div style={{ 
          background: "#f8f9fa", 
          padding: "20px", 
          borderRadius: "8px", 
          maxWidth: "600px",
          width: "100%",
          textAlign: "left",
          border: "1px solid #e6e8ed"
        }}>
          <h3 style={{ marginTop: 0, color: "#333", marginBottom: "15px" }}>Request Summary:</h3>
          {createdRequestId && (
            <div style={{ marginBottom: "8px" }}>
              <strong>Request ID:</strong> {createdRequestId}
            </div>
          )}
          <div style={{ marginBottom: "8px" }}>
            <strong>Request Type:</strong> Remove Delivery Restriction
          </div>
          <div style={{ marginBottom: "8px" }}>
            <strong>Restrictions to Remove:</strong> {selectedRestrictions?.length || 0}
          </div>
          {selectedRestrictions && selectedRestrictions.length > 0 && (
            <div style={{ marginTop: "10px", paddingLeft: "10px" }}>
              {selectedRestrictions.map((restriction, index) => (
                <div key={restriction.restrcnId || index} style={{ marginBottom: "4px", fontSize: "14px" }}>
                  • {restriction.restrcnName || restriction.restrictionName}
                </div>
              ))}
            </div>
          )}
        </div>
      </Grid>

      {/* What Happens Next */}
      <Grid item xs={12} style={{ 
        display: "flex",
        justifyContent: "center",
        marginBottom: "30px"
      }}>
        <div style={{ 
          background: "#e7f3ff", 
          padding: "15px", 
          borderRadius: "8px", 
          color: "#1976d2",
          maxWidth: "600px",
          width: "100%",
          textAlign: "left",
          border: "1px solid #b3d9ff"
        }}>
          <h3 style={{ marginTop: 0, marginBottom: "15px" }}>
            What happens next?
          </h3>
          <ul style={{ margin: 0, paddingLeft: "20px" }}>
            <li>Your request has been sent to Fannie Mae for review.</li>
            <li>Processing times vary based on the complexity of the request.</li>
            <li>You can track progress in the Lender Project Request Queue.</li>
          </ul>
        </div>
      </Grid>

      {/* Action Buttons */}
      <Grid container spacing={2} style={{ justifyContent: "center" }}>
        <Grid item>
          <Button 
            className="btn-submit"
            onClick={handleBackToProject}
          >
            Back to Project
          </Button>
        </Grid>
      </Grid>
    </Grid>
  );
};

const mapStateToProps = (state) => ({
  createdRequestId: selectCreatedRequestId(state),
  selectedRestrictions: selectSelectedRestrictions(state),
  requestCreatedButFilesFailed: selectRequestCreatedButFilesFailed(state)
});

const mapDispatchToProps = {
  resetRemoveDRWizard
};

SuccessPage.propTypes = {
  projectId: PropTypes.string.isRequired,
  createdRequestId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  selectedRestrictions: PropTypes.arrayOf(PropTypes.object),
  requestCreatedButFilesFailed: PropTypes.bool,
  resetRemoveDRWizard: PropTypes.func.isRequired
};

export default connect(mapStateToProps, mapDispatchToProps)(SuccessPage);

